import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import OneSNavPanel from "@/components/feature/OneSNavPanel";
import OneSOrdersTable from "@/components/feature/OneSOrdersTable";
import OneSTopBar from "@/components/feature/OneSTopBar";
import { useDiscussions } from "@/hooks/useDiscussions";
import type { UserRole } from "@/mocks/ai-logic";
import type { Order } from "@/mocks/orders";

export default function Home() {
  const navigate = useNavigate();
  const { toggle: toggleDiscussions } = useDiscussions();
  const [role, setRole] = useState<UserRole>("director");
  const [managerName, setManagerName] = useState("Иванов А.С.");
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  const handleRoleChange = useCallback((newRole: UserRole) => {
    setRole(newRole);
  }, []);

  return (
    <div className="h-screen flex flex-col bg-[#FFF9E6] overflow-hidden"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* 1C Title Bar */}
      <div className="h-[28px] flex items-center justify-between bg-[#FBED9E] px-3 flex-shrink-0 select-none border-b border-[#D5CA8A]"
      >
        <div className="flex items-center gap-3"
        >
          <div className="flex items-center gap-1.5"
          >
            <i className="ri-menu-line text-[#666666] text-[13px]"></i>
            <span className="text-[11px] text-[#2D2D2D] font-medium">Методическая база / Управление торговлей, редакция 11 (1С:Предприятие)</span>
          </div>
        </div>
        <div className="flex items-center gap-3"
        >
          <span className="text-[11px] text-[#666666]">Елена Голубева</span>
          <div className="w-px h-3 bg-[#D5CA8A]" />
          <i className="ri-settings-3-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-question-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-close-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
        </div>
      </div>

      {/* 1C Command Bar */}
      <div className="h-[32px] flex items-center gap-1 px-2 bg-[#FFF9E6] border-b border-[#D5CA8A] flex-shrink-0 select-none"
      >
        <div className="flex items-center gap-1"
        >
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-file-add-line text-[11px]"></i>
            <span>Создать</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-file-copy-line text-[11px]"></i>
            <span>Скопировать</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-delete-bin-line text-[11px]"></i>
            <span>Удалить</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1"
        >
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-filter-line text-[11px]"></i>
            <span>Фильтры</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-group-line text-[11px]"></i>
            <span>Группировки</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1"
        >
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-file-list-3-line text-[11px]"></i>
            <span>Отчёт</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-printer-line text-[11px]"></i>
            <span>Печать</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1 ml-auto"
        >
          {/* Role switch */}
          <div className="flex items-center gap-1 bg-[#FDF2B5] rounded p-[2px]"
          >
            <button
              onClick={() => handleRoleChange("manager")}
              className={`flex items-center gap-1 px-2 py-[2px] rounded text-[11px] font-medium cursor-pointer transition-all ${
                role === "manager"
                  ? "bg-[#E8DB6C] text-[#2D2D2D]"
                  : "text-[#2D2D2D] hover:bg-[#E8DB6C]"
              }`}
            >
              <i className="ri-user-line text-[10px]"></i>
              Менеджер
            </button>
            <button
              onClick={() => handleRoleChange("director")}
              className={`flex items-center gap-1 px-2 py-[2px] rounded text-[11px] font-medium cursor-pointer transition-all ${
                role === "director"
                  ? "bg-[#E8DB6C] text-[#2D2D2D]"
                  : "text-[#2D2D2D] hover:bg-[#E8DB6C]"
              }`}
            >
              <i className="ri-vip-crown-line text-[10px]"></i>
              Руководитель
            </button>
          </div>
          {role === "manager" && (
            <select
              value={managerName}
              onChange={(e) => setManagerName(e.target.value)}
              className="text-[11px] bg-[#FDF2B5] border border-[#D5CA8A] rounded px-2 py-[2px] text-[#2D2D2D] focus:outline-none cursor-pointer"
            >
              {["Иванов А.С.", "Петров Д.Н.", "Сидорова Е.М."].map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          )}
          <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
          <button
            onClick={() => navigate("/rop")}
            className="flex items-center gap-1 px-2 py-[2px] rounded text-[11px] cursor-pointer transition-colors bg-[#FDF2B5] text-[#2D2D2D] hover:bg-[#E8DB6C]"
          >
            <i className="ri-vip-crown-line text-[10px]"></i>
            <span>РОП</span>
          </button>
          <button
            onClick={() => navigate("/client360")}
            className="flex items-center gap-1 px-2 py-[2px] rounded text-[11px] cursor-pointer transition-colors bg-[#FDF2B5] text-[#2D2D2D] hover:bg-[#E8DB6C]"
          >
            <i className="ri-user-search-line text-[10px]"></i>
            <span>Клиент 360</span>
          </button>
          <button
            onClick={() => navigate("/manager-workspace")}
            className="flex items-center gap-1 px-2 py-[2px] rounded text-[11px] cursor-pointer transition-colors bg-[#FDF2B5] text-[#2D2D2D] hover:bg-[#E8DB6C]"
          >
            <i className="ri-user-settings-line text-[10px]"></i>
            <span>Рабочее место</span>
          </button>
          <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
          <button
            onClick={toggleDiscussions}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-3-line text-[11px]"></i>
            <span>Обсуждения</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <OneSTopBar />

      {/* Main area */}
      <div className="flex-1 flex overflow-hidden"
      >
        {/* 1C Navigation Panel */}
        <OneSNavPanel />

        {/* Orders table */}
        <div className="flex-1 flex flex-col min-w-0"
        >
          <OneSOrdersTable
            onRowSelect={setSelectedOrder}
            selectedOrderId={selectedOrder?.id ?? null}
          />
          {/* Bottom status bar */}
          <div className="h-[24px] flex items-center px-2 bg-[#FBED9E] border-t border-[#D5CA8A] text-[10px] text-[#666666] select-none"
          >
            <span>
              {selectedOrder
                ? `Выбран: ${selectedOrder.id} — ${selectedOrder.organization} — ${new Intl.NumberFormat("ru-RU", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(selectedOrder.amount)} ${selectedOrder.currency}`
                : "Выберите заказ для просмотра деталей"}
            </span>
            <span className="ml-auto">1С:Предприятие 8.3.25.1448</span>
          </div>
        </div>
      </div>
    </div>
  );
}